import React, { forwardRef, ReactNode } from 'react';
import {
  AccordionButton as ChakraAccordionButton,
  AccordionIcon as ChakraAccordionIcon,
  AccordionButtonProps,
  useStyleConfig,
} from '@chakra-ui/react';

import { Box } from '../Layout';

interface Props extends Omit<AccordionButtonProps, `css`> {
  children: ReactNode;
}

export const AccordionButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`AccordionButton`);

    return (
      <ChakraAccordionButton ref={ref} __css={styles} {...props}>
        <Box>{children}</Box>
        <ChakraAccordionIcon ml="auto" width={10} height={10} />
      </ChakraAccordionButton>
    );
  }
);
export type { Props as AccordionButtonProps };
